import type { PhraseEntry } from './types';

export function normalizeDatasetEntries(payload: unknown, page: number): PhraseEntry[] {
  const raw = Array.isArray((payload as Record<string, unknown>)?.data)
    ? (payload as Record<string, unknown>).data
    : Array.isArray((payload as Record<string, unknown>)?.items)
      ? (payload as Record<string, unknown>).items
      : Array.isArray((payload as Record<string, unknown>)?.results)
        ? (payload as Record<string, unknown>).results
        : [];

  return (raw as Record<string, unknown>[])
    .map((entry): PhraseEntry | null => {
      const frenchText =
        typeof entry?.fr === 'string' && entry.fr.trim()
          ? entry.fr.trim()
          : typeof entry?.french === 'string' && (entry.french as string).trim()
            ? (entry.french as string).trim()
            : typeof entry?.text === 'string' && (entry.text as string).trim()
              ? (entry.text as string).trim()
              : '';

      if (!frenchText) return null;

      return {
        id: String(entry?.id ?? `phrase:${frenchText}`),
        text: frenchText,
        frenchText,
        localText: typeof entry?.local === 'string' ? entry.local : '',
        source: typeof entry?.source === 'string' ? entry.source : '',
        domain: typeof entry?.domain === 'string' ? entry.domain : '',
        audioUrl: typeof entry?.audioUrl === 'string' ? entry.audioUrl : undefined,
      };
    })
    .filter((entry): entry is PhraseEntry => entry !== null);
}

export function buildStorageKey(userId: string | number | undefined, language: string): string {
  return `transcription_phrase_progress_${userId ?? 'anon'}_${language || 'none'}`;
}

export function loadProgress(storageKey: string): { completedPhrases: string[]; page: number } | null {
  try {
    const saved = localStorage.getItem(storageKey);
    if (!saved) return null;
    const progress = JSON.parse(saved);
    if (!progress.completedPhrases || !Array.isArray(progress.completedPhrases)) return null;
    return {
      completedPhrases: progress.completedPhrases,
      page: typeof progress.page === 'number' && progress.page >= 1 ? progress.page : 1,
    };
  } catch {
    return null;
  }
}

export function saveProgress(storageKey: string, completedIds: string[], page: number, currentIndex: number): void {
  try {
    localStorage.setItem(storageKey, JSON.stringify({
      completedPhrases: completedIds,
      page,
      currentIndex,
      timestamp: Date.now(),
    }));
  } catch {
    // silent
  }
}
